import { Component } from '@angular/core';
import { UIHeaderComponent, UIPREnvPickerComponent } from '@bannerflow/ui';
import { environment } from '../../environments/environment';

@Component({
    imports: [UIPREnvPickerComponent, UIHeaderComponent],
    templateUrl: './demo-page.component.html',
    styleUrl: './demo-page.component.scss'
})
export class DemoPageComponent {
    showPicker = environment.stage === 'sandbox';
}
